




























import Vue from "vue";
import { Component } from "vue-property-decorator";
//import { UserRole } from "@dataSource/Models/Users/User";

@Component({
  name: "app-layout"
})
export default class LayoutComponent extends Vue {
  constructor() {
    super();
    // console.log("LayoutComponent created");
  }

  MenuEnable = false;

  getClass() {
    var css: any = {};
    css["enable"] = this.MenuEnable;
    return css;
  }

  created() {}
  mounted() {
    document.title = this.$route.meta.title;
    this.MenuEnable = false;
  }

  innerShowNav = false;

  isAdmin(role: number): boolean {
    return false; //role == UserRole.Administrator;
  }
  isModerator(role: number): boolean {
    return false; //role == UserRole.ShopManager;
  }
  showMenu() {
    this.MenuEnable = !this.MenuEnable;
  }
  showNavigationPanel() {
    //  console.log("showNavigationPanel", this.innerShowNav)
    // var panelnav = this.$refs.panelnav as any;
    // panelnav.toggole();

    // debugger
    this.innerShowNav = !this.innerShowNav;
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./scripts/views/layouts/layout.vue